import { ThemeProperties } from '../../core';

export interface PaginationTheme {
	iconColor: string;
	iconDisabledColor: string;
	iconHoverBackground: string;
	iconActiveBackground: string;
	pageFont: string;
	pageHoverBackground: string;
	pageActiveBackground: string;
	focusRingColor: string;
}
export const theme = new ThemeProperties('pagination');
